import React from 'react';
import TableRowPdfPreviewAction, {
  TableRowPdfPreviewActionProps,
} from './TableRowPdfPreviewAction/TableRowPdfPreviewAction';
import { InputValueType } from '../../../../../hooks/useForm/useForm';
import TableRowNavigationAction, {
  TableRowNavigationActionProps,
} from './TableRowNavigationAction/TableRowNavigationAction';

export type VisibilityConfig = {
  field?: string;
  value?: InputValueType;
  values?: InputValueType[];
  not?: boolean;
  specificValue?: boolean;
};

export enum TableRowActionVariant {
  'pdfPreview' = 'tableRowPdfPreview',
  'navigation' = 'tableRowNavigation',
}

export type TableRowActionProps = {
  visibilityConfig?: VisibilityConfig;
} & (
  | (TableRowPdfPreviewActionProps & {
      variant: TableRowActionVariant.pdfPreview;
    })
  | (TableRowNavigationActionProps & {
      variant: TableRowActionVariant.navigation;
    })
);

export const TableRowAction = (props: TableRowActionProps) => {
  switch (props.variant) {
    case TableRowActionVariant.pdfPreview:
      return <TableRowPdfPreviewAction {...props} />;
    case TableRowActionVariant.navigation:
      return <TableRowNavigationAction {...props} />;
    default:
      return null;
  }
};

export default TableRowAction;
